import React, { useState } from 'react';
import styles from './ChangePasswordDialog.module.css';
import Modal from 'react-modal/lib/components/Modal';
import Button from '../forms/DefaultButton';
import validator from 'validator'

import { UserContext } from "../../UserContext";
import {
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider
} from "firebase/auth";
import { db } from "../../firebase-config"
import {
  collection,
  getDocs,
  query,
  where
} from "firebase/firestore"
import { updateUserInfo } from '../../Services/auth.service'
import { auth } from "../../firebase-config";

const ChangePasswordDialog = () => {

  const { changePassword, userLogout } = React.useContext(UserContext);
  function handler() {
    sendValidator()
  }

  const [oldPasswordError, setOldPasswordError] = useState(true)
  const [passwordError, setPasswordError] = useState(true)
  const [confirmationError, setConfirmationError] = useState(true)

  const [oldPassword, setOldPassword] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const passwordValidator = (e) => {
    setPassword(e.target.value)
    if (!validator.isEmpty(e.target.value)) {
      if (e.target.value.length >= 6) {
        if (e.target.value.match("(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})")) {
          return setPasswordError(false)
        } return setPasswordError('Sua senha precisa ter letras maiúsculas, minúsculas, numeros e caracteres especiais')
      } return setPasswordError('Sua senha precisa ter mais de 6 digitos')
    } return setPasswordError('Digite uma senha')
  }


  const passwordConfirmation = (e) => {
    if (e.target.name == "confirmation") {
      setConfirmPassword(e.target.value)
      if (!validator.equals(e.target.value, password))
        return setConfirmationError('As senhas não são iguais')
      return setConfirmationError(false)
    }
    if (!validator.equals(e.target.value, confirmPassword))
      return setConfirmationError('As senhas não são iguais')
    return setConfirmationError(false)
  }

  const sendValidator = () => {
    let newPassword
    const user = auth.currentUser
    const credential = EmailAuthProvider.credential(
      user.email,
      oldPassword
    )
    reauthenticateWithCredential(user, credential).then(() => {
      if (password == confirmPassword)
        newPassword = password
      else
        return alert('As senhas não são iguais')
      updatePassword(user, newPassword).then(async () => {
        let userData = {}
        const queryPermission = collection(db, "permission-user")
        const q = query(queryPermission, where("email", "==", user.email))
        const docs = await getDocs(q)
        docs.forEach((doc) => {
          userData = doc.data()
          userData.changePassword = false
          updateUserInfo(doc.id, userData).catch(
            (e) => {
              return console.error(e)
            }
          )
        })
        alert('Senha alterada com sucesso.\nSeja bem vindo ao Portal de  Digital Optimization!')
        setTimeout(() => {
          window.location.reload()
        }, 1500);
      }).catch(function (e) {
        userLogout(auth)
        alert('Erro ao alterar senha.\n Por favor efetuar login novamente.')
        console.error(e)
        window.location.reload()
      })
    }).catch((e) => {
      console.error(e)
      return alert('Senha incorreta')
    });
  }

  return (
    <Modal
      isOpen={!!changePassword}
      ariaHideApp={false}
      overlayClassName={styles.ChangePasswordModalOverlay}
      className={styles.ChangePasswordModal}
    >
      <div className={styles.ChangePasswordDialog}>
        <div className={styles.titleBox}>
          <h1>Por favor troque sua senha</h1>
        </div>
        <div>
          <form autocomplete="off">
            <label for="password">Digite sua senha atual</label>
            <input
              autocomplete="new-password"
              type="password"
              name="old_password"
              onChange={(e) => {
                setOldPassword(e.target.value)
                if (validator.isEmpty(e.target.value))
                  return setOldPasswordError('Digite sua senha')
                return setOldPasswordError(false)
              }}
            />
            <small className={styles.errorMsg}>{oldPasswordError}</small>
            <br />
            <label for="password">Digite sua nova senha</label>
            <input
              maxLength="24"
              autocomplete="new-password"
              type="password"
              name="password"
              onChange={(e) => {
                passwordValidator(e),
                  passwordConfirmation(e)
              }}
            />
            <small className={styles.errorMsg}>{passwordError}</small>
            <br />
            <label for="confirmation">Confirme sua nova senha</label>
            <input
              maxLength="24"
              autocomplete="new-password"
              type="password"
              name="confirmation"
              onChange={(e) => {
                passwordConfirmation(e)
              }}
            />
            <small className={styles.errorMsg}>{confirmationError}</small>
          </form>
        </div>
        <div className={styles.confirmButton}>
          <Button
            type="red"
            size="MD"
            onClick={() => {
              userLogout(auth)
              window.location.reload()
            }}
            children="Logout"
          />

          <Button
            type={!(confirmationError == false && passwordError == false && oldPasswordError == false) ? 'disabled' : 'red'}
            size="MD"
            onClick={() => handler()}
            children="Confirmar"
          />

        </div>
      </div>
    </Modal>
  )
}

export default ChangePasswordDialog;
